import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';
import { PortainerSelect } from '@@/form-components/PortainerSelect';

import { capabilityOptions } from './constants';

export function CapabilityItem({ item, onChange, index }: ItemProps<string>) {
  return (
    <InputGroup size="small">
      <InputGroup.Addon>Capability</InputGroup.Addon>
      <PortainerSelect
        options={capabilityOptions}
        value={item}
        onChange={(value) => onChange(value || '')}
        data-cy={`allowed-capability-${index}-select`}
        isClearable={false}
        size="sm"
      />
    </InputGroup>
  );
}
